import React from "react";
import { Container, Col, Row, Button } from "react-bootstrap";
import styles from "./Bienvenida.module.css";
import sideImage from "../../src/assets/img/login/sky-home.svg";
import logo from "../assets/img/logos/sky-new-2020-seeklogo2.svg";

export const Bienvenida = () => {
  return (
    <Container className={styles.container}>
      <Row className={styles.rowContainer}>
        {/* Columna izquierda: Formulario */}
        <Col xs={12} md={7} className={styles.loginForm}>
          <div className={styles.estiloForm}>
            <img src={logo} className={styles.logo} alt="Sky Logo" />
            <div className={styles.gris}>Bienvenido a Mi Sky</div>
            <hr className={styles.line} />
            <div className={styles.textos}>
              Para ingresar selecciona la opción que corresponda a tu cuenta
              dependiendo de tu fecha de contratación:
            </div>
            <div className={styles.textosky}>Soy cliente Sky</div>
            <Row className={styles.buttonContainer}>
              <Col className="text-end pe-md-2 pe-0">
                <Button
                  className={styles.botonSwitchActivo}
                  as="a"
                  href="/login"
                >
                  Antes de Marzo 2025
                </Button>
              </Col>
              <Col className="ps-md-2 ps-0">
                <Button
                  className={styles.botonSwitchInactivo}
                  as="a"
                  href="https://micuenta.sky.com.mx/login"
                >
                  A partir de Marzo 2025
                </Button>
              </Col>
            </Row>
          </div>
        </Col>

        {/* Columna derecha: Imagen */}
        <Col xs={12} md={5} className={styles.imageContainer}>
          <img src={sideImage} className={styles.sideImage} alt="Sky Home" />
        </Col>
      </Row>
    </Container>
  );
};
